import Splash from "./components/splash/Splash.jsx";
import Case from "./components/casestudy/Case.jsx";
import Teaser from "./components/teaser/Teaser.jsx";
import Roadblock from "./components/roadblock/Roadblock.jsx";
import Mural from "./components/mural/Mural.jsx";
import Outheisted from "./components/outheisted/Outheisted.jsx";
import Social from "./components/social/Social.jsx";
import Filter from "./components/filter/Filter.jsx";
import Reviews from "./components/reviews/Reviews.jsx";
import { useEffect, useState } from "react";

function App() {
  const [novid, setNoVid] = useState(false);

  useEffect(() => {
    if (
      window.location.origin === "https://heistday.vercel.app" ||
      window.location.href.indexOf("novid") !== -1
    ) {
      setNoVid(true);
    }
  }, [window.location]);
  return (
    <div className="App">
      <Splash />
      {!novid && <Case />}
      <Teaser />
      <Roadblock />
      <Mural />
      <Outheisted />
      <Social />
      <Filter />
      <Reviews novid={novid} />
    </div>
  );
}

export default App;
